<template>
  <svg
    width="13"
    height="12"
    viewBox="0 0 13 12"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      class="like-outline"
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M0 3.59625C0 6.93686 3.27139 10.4337 5.28125 11.4965C5.65283 11.693 5.9813 11.8063 6.23799 11.82C6.24964 11.8206 6.26115 11.821 6.2725 11.8213H6.28125V11.82H6.28812C7.9025 11.7906 12.5612 7.58187 12.5612 3.59688C12.5612 1.68125 10.9837 0 9.18375 0C8.23615 0 7.49412 0.43304 6.95313 0.933918C6.67665 1.18989 6.45269 1.46358 6.28062 1.70625C6.10829 1.46337 5.88428 1.1898 5.60797 0.934021C5.0666 0.432871 4.32448 0 3.37687 0C1.57812 0 0 1.68125 0 3.59625Z"
      :fill="isActive ? '#E0245E' : 'currentColor'"
    />
    <path
      class="like-background"
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M5.68267 1.00783C5.6784 1.00385 5.67413 0.999879 5.66984 0.99591C5.63952 0.967843 5.60857 0.93999 5.57699 0.912415C5.61304 0.943888 5.64826 0.975724 5.68267 1.00783ZM1 3.65939C1 2.24251 2.13938 1.00001 3.43937 1.00001C5.02 1.00001 5.9025 2.83439 5.91125 2.85314C6.05562 3.20439 6.63437 3.20439 6.77812 2.85314C6.78562 2.83501 7.66813 1.00001 9.24813 1.00001C10.5481 1.00001 11.6875 2.24251 11.6875 3.65939C11.6875 7.24751 7.2925 10.9069 6.34375 10.9456C5.39625 10.9069 1 7.24689 1 3.65939Z"
      :fill="isActive ? '#E0245E' : 'currentColor'"
    />
  </svg>
</template>

<script>
export default {
  props: {
    isActive: {
      type: Boolean,
      default: false,
    },
  },
}
</script>

<style lang="scss">
svg  {
  &:hover .like-outline, &:hover .like-background{
    color: #E0245E;
  }
}

.like-outline {
  color: #657786;
}
.like-background {
  color: #fff;
}
</style>
